import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { toReadableText } from "../utils/utils";
import { DataLoaderOption, StandaloneSyncSystem } from "../../api/datasystems";
import { DataLoaderSystemComponent } from "./DataLoaderSystem";

interface StandaloneSyncSystemCardProps {
  syncSystem: StandaloneSyncSystem;
  syncSystemOptions: DataLoaderOption[];
}

export function StandaloneSyncSystemCard(
  props: Readonly<StandaloneSyncSystemCardProps>
) {
  const syncSystemTypeLabel = toReadableText(props.syncSystem.system_type);

  return (
    <Card
      sx={{
        minWidth: "500px",
        width: "500px",
        margin: "0px 10px 10px 0px",
        boxShadow: "0px 14px 80px rgba(34, 35, 58, 0.2)",
      }}
    >
      <CardHeader
        subheader={props.syncSystem.name}
        action={
          <IconButton aria-label="settings" size="large">
            {toReadableText("SYNC SYSTEM")}
          </IconButton>
        }
      />
      <CardContent>
        <Typography variant={"h4"} style={{ marginTop: "10px" }}>
          {syncSystemTypeLabel}
        </Typography>
        <Divider />
        <DataLoaderSystemComponent
          name={props.syncSystem.name}
          type={props.syncSystem.system_type}
          id={props.syncSystem.id}
          configRevisionId={props.syncSystem.config_revision_id}
          existing={true}
          disableTypeEdit={true}
          onDataLoaderSystemChange={() => {}}
          dataLoaderOptions={props.syncSystemOptions}
        />
      </CardContent>
    </Card>
  );
}
